// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--oCw_f","text":"_7a3fb80146--text--SnsX_","formatted":"_7a3fb80146--formatted--TuNlX"};